import {
  InboxIcon,
  PaperAirplaneIcon,
  PencilSquareIcon,
  TrashIcon,
  ExclamationTriangleIcon,
} from "@heroicons/react/24/outline";

const ICON_MAP = {
  InboxIcon,
  PaperAirplaneIcon,
  PencilSquareIcon,
  TrashIcon,
  ExclamationTriangleIcon,
};

export function InboxSidebar({ folders, activeFolder, onSelectFolder }) {
  return (
    <div className="w-56 border-r border-slate-200 bg-white flex flex-col h-full flex-shrink-0">
      <div className="p-4 border-b border-slate-100">
        <h2 className="text-lg font-semibold text-slate-900">Mail</h2>
      </div>
      <nav className="flex-1 px-2 py-2">
        {folders.map((folder) => {
          const Icon = ICON_MAP[folder.icon];
          const isActive = folder.id === activeFolder;
          return (
            <button
              key={folder.id}
              onClick={() => onSelectFolder(folder.id)}
              className={`w-full flex items-center justify-between px-3 py-2 rounded-lg text-sm mb-0.5 transition-colors cursor-pointer ${
                isActive
                  ? "bg-slate-100 text-slate-900 font-medium"
                  : "text-slate-600 hover:bg-slate-50 hover:text-slate-900"
              }`}
            >
              <div className="flex items-center gap-3">
                {Icon && <Icon className="h-5 w-5" />}
                <span>{folder.label}</span>
              </div>
              {folder.count > 0 && (
                <span
                  className={`text-xs font-medium ${
                    isActive ? "text-slate-700" : "text-slate-400"
                  }`}
                >
                  {folder.count}
                </span>
              )}
            </button>
          );
        })}
      </nav>
    </div>
  );
}
